import { OwnerStateThemeType } from ".";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  MuiPaper: {
    styleOverrides: {
      root: ({ theme }: OwnerStateThemeType) => ({
        backgroundColor: theme.palette.customColors.tableHeaderBg,
        backgroundImage: "none",
      }),
    },
  },
};
